import '../main';
import { Extension } from '@tiptap/core';
/**
 * This extension allows you to color your text.
 * @see https://tiptap.dev/api/extensions/background-color
 */
export const BackgroundColor = Extension.create({
    name: 'backgroundColor',
    addOptions() {
        return {
            types: ['textStyle'],
        };
    },
    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    backgroundColor: {
                        default: null,
                        parseHTML: element => {
                            var _a;
                            const isTransparent = (v) => {
                                const lower = v.toLowerCase().trim();
                                return !lower
                                    || lower === 'transparent'
                                    || lower === 'initial'
                                    || lower === 'inherit'
                                    || lower === 'unset'
                                    || lower === 'rgba(0, 0, 0, 0)'
                                    || lower === 'rgba(0,0,0,0)';
                            };
                            // Prefer the raw inline `style` attribute so we preserve
                            // the original format (e.g. `#rrggbb`) instead of the
                            // computed `rgb(...)` value returned by `element.style.backgroundColor`.
                            // When nested spans are merged the style attribute may contain
                            // multiple `background-color:` declarations (parent;child). We should pick
                            // the last declaration so the child's background color takes priority.
                            const styleAttr = element.getAttribute('style');
                            if (styleAttr) {
                                const decls = styleAttr
                                    .split(';')
                                    .map(s => s.trim())
                                    .filter(Boolean);
                                for (let i = decls.length - 1; i >= 0; i -= 1) {
                                    const parts = decls[i].split(':');
                                    if (parts.length >= 2) {
                                        const prop = parts[0].trim().toLowerCase();
                                        const val = parts.slice(1).join(':').trim();
                                        if (prop === 'background-color') {
                                            const clean = val.replace(/['"]+/g, '');
                                            return isTransparent(clean) ? null : clean;
                                        }
                                    }
                                }
                            }
                            const raw = ((_a = element.style.backgroundColor) === null || _a === void 0 ? void 0 : _a.replace(/['"]+/g, '')) || '';
                            return isTransparent(raw) ? null : raw;
                        },
                        renderHTML: attributes => {
                            if (!attributes.backgroundColor) {
                                return {};
                            }
                            return {
                                style: `background-color: ${attributes.backgroundColor}`,
                            };
                        },
                    },
                },
            },
        ];
    },
    addCommands() {
        return {
            setBackgroundColor: backgroundColor => ({ chain }) => {
                return chain().setMark('textStyle', { backgroundColor }).run();
            },
            unsetBackgroundColor: () => ({ chain }) => {
                return chain().setMark('textStyle', { backgroundColor: null }).removeEmptyTextStyle().run();
            },
        };
    },
});
